import React from "react";
import PropTypes from "prop-types";

/**
 * WhatsApp icon component.
 */
export const WhatsAppIcon = ({
  className = "tw-w-5 tw-h-5 tw-flex-shrink-0",
  width = "20",
  height = "20",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.63C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2ZM12.04 20.15C10.56 20.15 9.11 19.76 7.85 19.01L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 14.99 3.8 13.47 3.8 11.91C3.8 7.37 7.5 3.67 12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15ZM16.56 14.39C16.31 14.27 15.09 13.67 14.86 13.58C14.63 13.5 14.47 13.46 14.3 13.7C14.14 13.95 13.66 14.51 13.52 14.67C13.37 14.84 13.23 14.86 12.98 14.73C12.73 14.61 11.92 14.35 10.97 13.5C10.23 12.84 9.73 12.02 9.58 11.77C9.44 11.52 9.56 11.39 9.69 11.26C9.8 11.15 9.94 10.97 10.06 10.82C10.18 10.67 10.23 10.57 10.31 10.4C10.39 10.23 10.35 10.09 10.29 9.97C10.23 9.84 9.73 8.62 9.53 8.11C9.32 7.62 9.12 7.69 8.96 7.68C8.82 7.67 8.65 7.67 8.49 7.67C8.32 7.67 8.05 7.73 7.82 7.98C7.59 8.23 6.94 8.84 6.94 10.07C6.94 11.3 7.84 12.49 7.96 12.66C8.09 12.82 9.72 15.34 12.22 16.42C12.82 16.68 13.28 16.83 13.64 16.95C14.24 17.14 14.78 17.11 15.22 17.05C15.7 16.98 16.7 16.44 16.91 15.86C17.11 15.27 17.11 14.77 17.05 14.67C16.99 14.57 16.81 14.51 16.56 14.39Z"
      fill="currentColor"
    />
  </svg>
);

WhatsAppIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

WhatsAppIcon.defaultProps = {
  className: "tw-w-5 tw-h-5 tw-flex-shrink-0",
  width: "20",
  height: "20",
};
